// Lista de investidores e seus vídeos

export const investidores = {
    Pedrão: 'http://www.youtube.com/embed/3ibBIWqK5lE?si=bYj9CbRSfGx3W51W',
    Zeca: 'https://www.youtube.com/embed/6HQdaLBfGf4?si=WojKxPdkFCCx0od7',
    Vinicius: 'https://www.youtube.com/embed/d7w8dftCmeo?si=KilCPXkXcpZ6LKIn',
    Smurf: 'https://www.youtube.com/embed/i-DbCpBiCj0?si=dDnRNY6RFmFm_8_9',
    Ronaldo: 'https://www.youtube.com/embed/sOg-QA7BfSk?si=L7GnbPyuKy0GCz8E',
    Rodrigo: 'https://www.youtube.com/embed/unM9q4F8NLA?si=q371lF91FbHr-bOF',
    RobertoDavid: 'https://www.youtube.com/embed/-_w2j1hfp1U?si=5j3vgmf9H998hFEW',
    Renato: 'https://www.youtube.com/embed/DNZ5zFnM754?si=8sWoOPaCxUgZ12wd',
    Raquel: 'https://www.youtube.com/embed/r_IDzN1jTEI?si=oPaLLZKywnBwNO6z',
    Rafael: 'https://www.youtube.com/embed/5_Pbd6cRbvA?si=Op-x92q8Mu-EWLHf',
    Patrícia: 'https://www.youtube.com/embed/kwDE8kTaGpk?si=TvKSn3zsZ44n9xJh',
    Michel: 'https://www.youtube.com/embed/C63HfRCzkUQ?si=T7WfkbWelagWU73U',
    Marcelo: 'https://www.youtube.com/embed/ppAjG_3KWNE?si=1jGxLOt_IQL1uPpg',
    Salim: 'https://www.youtube.com/embed/ppAjG_3KWNE?si=1jGxLOt_IQL1uPpg',
    Mara: 'https://www.youtube.com/embed/3-FyKYp5sac?si=auigaqFA9Tnp74vL',
    Lineu: 'https://www.youtube.com/embed/3v4k1lBz4-A?si=hj-9dyDIIxqmn8gr',
    Leo: 'https://www.youtube.com/embed/6HG5OCyGCUA?si=ZOD-F-UZAxpDP-c9',
    Juliano: 'https://www.youtube.com/embed/1zujgW8lH-s?si=7KKXFl2Hdi7-rh-e',
    Igor: 'https://www.youtube.com/embed/0YXGtrxVYPk?si=PZFWvlFtHWvqZetH',
    Gustavo: 'https://www.youtube.com/embed/wrQrywS4h7U?si=1rFePB1Mt-_Sq-ik',
    Gourmet: 'https://www.youtube.com/embed/VNeFCcwiY_k?si=b1sUJ3wQpdDUT1jB',
    Gonçalves: 'https://www.youtube.com/embed/3u8ce1yd-vg?si=_rRxPirh1UKDXHPU',
    Glenda: 'https://www.youtube.com/embed/hMmK5OdvhWw?si=MhDjx9bgW0n_jjKd',
    Elmo: 'https://www.youtube.com/embed/0uijvA09CVw?si=o8Bf3sp4Hf8Qk2v_',
    David: 'https://www.youtube.com/embed/vV695rlbI2A?si=PbA0e3BFFkR2_KfI',
    Daniel: 'https://www.youtube.com/embed/NLXpg183u4k?si=z-wxuZ9RL_6kwWsU',
    Dani: 'https://www.youtube.com/embed/e-QYrbDjp_0?si=cNnl_6DqBzDvmaen',
    Coutinho: 'https://www.youtube.com/embed/rRCDJua2Y8s?si=jQUTCQhhbhjz0FuF',
    CarlosHenrique: 'https://www.youtube.com/embed/cdpTYEmLvc4?si=rhSBI3PHd9BN7nDJ',
    Carlos: 'https://www.youtube.com/embed/9aGHFnCg8gw?si=GtIXGiSGOOOzuww3',
    Kamache: 'https://www.youtube.com/embed/-MtiY2Z6maA?si=fNf0Fyi1dy64_0BK',
    Barata: 'https://www.youtube.com/embed/0D_GrzEOGjc?si=gji5gqYoU_Jah-ax',
    Arturo: 'https://www.youtube.com/embed/GplDxfPyOec?si=H0f_ykpe6SFbt8vq',
    Arthur: 'https://www.youtube.com/embed/bpiyzQFS2P0?si=p-Vh-ckTYtYUsj9p',
    Andrea: 'https://www.youtube.com/embed/jYU4OTSjOFk?si=6qd22ByDtBAP1JWD',
    Alexandre: 'https://www.youtube.com/embed/25Z1_-_ViYQ?si=P3PQt3qP4IJ09D7d',
    Teresa: 'https://www.youtube.com/embed/-njUSVUUGuM?si=XUXVamnq9cLl1Xcq',
    Solange: 'https://www.youtube.com/embed/RAUYCfgrin8?si=BIjkKB2uwGCHNjsD',
    Rafa: 'https://www.youtube.com/embed/vcqPWHwjCKk?si=_UqT21Ld2TLZlxrW',
    Paulo: 'https://www.youtube.com/embed/CvayXRVXU3Y?si=cNf-8Mq8oVMOylMu',
    Senna: 'https://www.youtube.com/embed/v837SFR0oKM?si=mP2XkB7eTLZQSFFm',
    Julio: 'https://www.youtube.com/embed/GP4O_eIPaeE?si=QF202Xb-KiJZMFom',
    Henry: 'https://www.youtube.com/embed/7GzVhlGRquQ?si=B6uv7-XKxspc4BvA',
    Flávio: 'https://www.youtube.com/embed/uwR4WCpqLnw?si=F_b7i1hKhOMTQPy1',
    Ewerton: 'https://www.youtube.com/embed/ZQ-FqerS1kc?si=a4hKLmoK4wNgRtWn',
    Bragança: 'https://www.youtube.com/embed/ASD0hk6QhD0?si=uUUClCscPhnxhMRb',
    Andre: 'https://www.youtube.com/embed/5LZT0zvu2mw?si=YcujRG9L1rx7Ua54',
    Rubens: 'https://www.youtube.com/embed/Fwr--6ebfck?si=8rafm-SB82WUZ0Ri',
    SejaPioneiro: 'https://www.youtube.com/embed/PxvhzRjMBQM?si=0g0WQkJHf_zO6_Jz',
    Convite_Exclusivo_Seja_Pioneiro: 'https://www.youtube.com/embed/QPUroOa8ECk?si=oBTCZe9bTZRHXklo',
    Marino: 'https://www.youtube.com/embed/QPUroOa8ECk?si=oBTCZe9bTZRHXklo',
    Juliana: 'https://www.youtube.com/embed/0P7a2TfAEh0?si=Dm9XFbvb5W9OZ8fR',
    

    // Adicione mais investidores aqui conforme precisar
  };
  